import { getOrElse, inProgress, notAsked, RemoteData, success } from 'ngx-remotedata';
import { ErrorWrapper } from '../models/common';
import { AcknowledgeMessage, LoadMessagesActions, LoadMessagesActionTypes } from './actions';
import { SponsorMessage } from './model';

export type MessagingState = RemoteData<SponsorMessage[], ErrorWrapper>;
const initialState = notAsked<SponsorMessage[], ErrorWrapper>();

export function messagingReducer(
    state: MessagingState = initialState,
    action: LoadMessagesActions
): MessagingState {
    switch (action.type) {
        case LoadMessagesActionTypes.LOAD_MESSAGES:
            return inProgress([] as SponsorMessage[]);
        case LoadMessagesActionTypes.LOAD_MESSAGES_SUCCESS:
            return success((action as { payload: SponsorMessage[] }).payload);
        case LoadMessagesActionTypes.LOAD_MESSAGES_FAILURE:
            // Deliberately an empty list rather than a failure state. A user without the
            // sponsorMessaging feature gets a 403 here, which is the ordinary case for most
            // tenants -- not something to raise an error over.
            return success([] as SponsorMessage[]);
        case LoadMessagesActionTypes.ACKNOWLEDGE_MESSAGE: {
            // Dropped optimistically so the modal advances to the next message on click rather
            // than waiting on the round trip.
            const { id } = (action as AcknowledgeMessage).payload;
            const messages = getOrElse(state, [] as SponsorMessage[]);
            return success(messages.filter(message => message.id !== id));
        }
        case LoadMessagesActionTypes.ACKNOWLEDGE_MESSAGE_FAILURE:
            // Stays dropped. Re-showing a message the user just dismissed is worse than losing one
            // acknowledgement, and nothing is lost: the server keeps serving it until an
            // acknowledgement lands, so the next login shows it again.
            return state;
        default:
            return state;
    }
}
